import { types } from "../types/types";

const initialState = {
  checking: true,
  user: {},
  userInUserRole: {},
  isUserAuthenticated: false,
  isSuccessConfirmation:false,
  isFailedConfirmationError:false,
  isFailedConfirmationValidation:false,
  isSuccessRegister:false,
  isFailedRegister:false

};
export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AUTH_LOGIN:
      
      return {
        ...state,
        user: action.payload,
        checking: false,
        isUserAuthenticated: true,
      };

    case types.AUTH_CHEKING_FINISH_LOGIN_STATE:
      
      return {
        ...state,
        checking: false,
        user: {},
        isUserAuthenticated:false
      };

    case types.AUTH_LOGOUT:
      return {
        checking: false,
        user: {},
        isUserAuthenticated: false
      };

    /*
    case types.AUTH_SELECT_IN_USER_ROLE:
      return {
        ...state,
        userInUserRole: action.payload,
      };
    */

    case types.AUTH_CLEAN:
      return {
        ...state,
        user: {},
      };

    case types.AUTH_SUCCESS_CONFIRMATION_REGISTER:
      return {
        ...state,
         isSuccessConfirmation:true,
        
      };

    case types.AUTH_FAILED_CONFIRMATION_REGISTER_ERROR:
      return {
        ...state,
         isSuccessConfirmation:false,
         isFailedConfirmationError:true,
      };

      case types.AUTH_FAILED_CONFIRMATION_REGISTER_VALIDATION:
      return {
        ...state,
         isSuccessConfirmation:false,
         isFailedConfirmationValidation:true,
      };

      case types.AUTH_CONFIRMATION_REGISTER_CLEAN:
      return {
        ...state,
         isSuccessConfirmation:false,
         isFailedConfirmationError:false,
         isFailedConfirmationValidation:false
        
      };

      case types.AUTH_SUCCESS_REGISTER:
      return {
        ...state,
         isSuccessRegister:true,
         isFailedRegister:false,
      };

    case types.AUTH_FAILED_REGISTER:
      return {
        ...state,
         isSuccessRegister:false,
         isFailedRegister:true,
      };

    case types.AUTH_CLEAN_REGISTER:
      return {
        ...state,
         isSuccessRegister:false,
         isFailedRegister:false,
      };

    /*
    case types.AUTH_START_REGISTER_ADMIN:
      return {
        ...state,
        user: action.payload,
      };
      */

    default:
      return state;
  }
};
